export type ExperienceRole = {
  title: string;
  period: string;
};

export type ExperienceItem = {
  company: string;
  employmentType: string;
  location: string;
  period: string;
  duration: string;
  current?: boolean;
  roles: ExperienceRole[];
};

export const experienceData: ExperienceItem[] = [
  {
    company: "Generation Next Technology",
    employmentType: "Full-time",
    location: "Karachi, Sindh, Pakistan · On-site",
    period: "Jul 2026 — Present",
    duration: "Current position",
    current: true,
    roles: [{ title: "Software Engineer", period: "Jul 2026 — Present" }],
  },
  {
    company: "Sync Journey",
    employmentType: "Full-time",
    location: "Karachi, Sindh, Pakistan · On-site",
    period: "Mar 2025 — Jun 2026",
    duration: "1 yr 4 mos",
    roles: [
      { title: "Associate Software Engineer", period: "Jul 2025 — Jun 2026" },
      { title: "Intern Software Engineer", period: "Mar 2025 — Jun 2025" },
    ],
  },
  {
    company: "QF Network",
    employmentType: "Internship",
    location: "Karachi, Sindh, Pakistan · On-site",
    period: "Mar 2024 — May 2024",
    duration: "3 mos",
    roles: [{ title: "WordPress Developer", period: "Mar 2024 — May 2024" }],
  },
  {
    company: "Sonic Textile Industries (Pvt) Ltd",
    employmentType: "Full-time",
    location: "Karachi, Sindh, Pakistan · On-site",
    period: "Jul 2023 — Oct 2023",
    duration: "4 mos",
    roles: [{ title: "ERP Executive and Web Development", period: "Jul 2023 — Oct 2023" }],
  },
];
